import { useEffect } from 'react';
const TITLE = 'Home Remodeling & Repair Northwest Houston, TX | JV Home Service';
const META_TAGS: Array<{
  key: 'name' | 'property';
  value: string;
  content: string;
}> = [{
  key: 'name',
  value: 'description',
  content: 'Licensed home remodeling, roofing, siding, foundation repair and demolition in Northwest Houston, TX. 10+ years experience. Free estimates. Se habla español. Call (832) 996-1200.'
}, {
  key: 'name',
  value: 'keywords',
  content: 'home remodeling Northwest Houston, roofing contractor Houston TX, siding replacement Houston, foundation repair Houston TX, kitchen remodeling Houston, bathroom remodeling Northwest Houston, general contractor Houston TX, home repair Cypress TX'
}, {
  key: 'name',
  value: 'robots',
  content: 'index, follow'
}, {
  key: 'property',
  value: 'og:title',
  content: 'Home Remodeling & Repair Northwest Houston | JV Home Service'
}, {
  key: 'property',
  value: 'og:description',
  content: 'Licensed remodeling, roofing, siding & foundation repair in Northwest Houston. Free estimates. Call (832) 996-1200.'
}, {
  key: 'property',
  value: 'og:url',
  content: 'https://jvhomeservice.com'
}, {
  key: 'property',
  value: 'og:type',
  content: 'website'
}];
const LOCAL_BUSINESS_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'GeneralContractor',
  name: 'JV Home Service',
  url: 'https://jvhomeservice.com',
  telephone: '+18329961200',
  email: 'Jvhomeservice759@gmail.com',
  description: 'Professional home remodeling, roofing, siding, foundation repair and demolition in Northwest Houston, TX. Licensed and insured. 10+ years experience, 250+ projects completed. Se habla español.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Houston',
    addressRegion: 'TX',
    addressCountry: 'US'
  },
  areaServed: ['Northwest Houston', 'Cypress TX', 'Spring TX', 'Tomball TX', 'Katy TX', 'The Woodlands TX', 'Houston TX'],
  priceRange: '$$',
  openingHoursSpecification: [{
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '07:00',
    closes: '18:00'
  }, {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Saturday'],
    opens: '08:00',
    closes: '16:00'
  }],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Home Remodeling & Repair Services Houston',
    itemListElement: ['Home Remodeling Northwest Houston', 'Roofing Contractor Houston TX', 'Siding Replacement Houston', 'Foundation Repair Houston TX', 'Kitchen Remodeling Houston', 'Bathroom Remodeling Houston', 'Demolition Services Houston'].map(name => ({
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name
      }
    }))
  }
};
const FAQ_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [{
    question: 'How do I get a free estimate for home remodeling in Houston?',
    answer: 'Call or text (832) 996-1200, message us on WhatsApp, or fill out the form on our website. We schedule a free on-site visit usually within 48 hours and give you a written estimate with no pressure.'
  }, {
    question: 'Is JV Home Service licensed and insured in Texas?',
    answer: 'Yes. JV Home Service is fully licensed and insured for residential and commercial work in Houston, TX and surrounding areas including Cypress, Spring and Tomball.'
  }, {
    question: 'How long do remodeling and roofing projects take?',
    answer: 'Small repairs take 1-2 days. Full re-roofs typically 2-5 days. Kitchen and bathroom remodels range from 2 to 6 weeks. Julio provides a timeline estimate before starting any project.'
  }, {
    question: 'Do you offer services in Spanish?',
    answer: 'Yes, se habla español. Our bilingual team communicates clearly in both English and Spanish throughout the entire project.'
  }, {
    question: 'Do you serve commercial properties in Houston?',
    answer: 'Yes. JV Home Service handles both residential and commercial projects including remodeling, roofing, siding, foundation repair and demolition in the Houston metro area.'
  }, {
    question: 'Do you warranty your work?',
    answer: 'Yes. We stand behind our workmanship on every project. Contact us for specific warranty details on your type of project.'
  }].map(item => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer
    }
  }))
};
const BREADCRUMB_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [{
    name: 'Home',
    item: 'https://jvhomeservice.com/'
  }, {
    name: 'Services',
    item: 'https://jvhomeservice.com/#services'
  }, {
    name: 'Gallery',
    item: 'https://jvhomeservice.com/#gallery'
  }, {
    name: 'Contact',
    item: 'https://jvhomeservice.com/#contact'
  }].map((entry, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: entry.name,
    item: entry.item
  }))
};

/**
 * Injects the SEO title, meta tags, canonical link and JSON-LD schema into
 * document.head. Rendered once from App so every view carries the markup.
 */
export function SeoHead() {
  useEffect(() => {
    const head = document.head;
    const created: Element[] = [];
    document.title = TITLE;
    document.documentElement.lang = 'en';
    META_TAGS.forEach(tag => {
      let el = head.querySelector<HTMLMetaElement>(`meta[${tag.key}="${tag.value}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(tag.key, tag.value);
        head.appendChild(el);
        created.push(el);
      }
      el.setAttribute('content', tag.content);
    });
    let canonical = head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      head.appendChild(canonical);
      created.push(canonical);
    }
    canonical.href = 'https://jvhomeservice.com/';
    const schemas = [LOCAL_BUSINESS_SCHEMA, FAQ_SCHEMA, BREADCRUMB_SCHEMA];
    schemas.forEach((schema, index) => {
      const id = `jv-schema-${index}`;
      let script = document.getElementById(id) as HTMLScriptElement | null;
      if (!script) {
        script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        head.appendChild(script);
        created.push(script);
      }
      script.textContent = JSON.stringify(schema);
    });
    return () => {
      created.forEach(el => el.remove());
    };
  }, []);
  return null;
}